/* Kaarten en rijen met data-ke-instroom lopen een voor een in beeld zodra je
   ernaartoe scrollt en blijven daarna staan. Zelfde mechanisme als Earthle's
   earthle-flow.js: een IntersectionObserver plus een vangnet voor pagina's
   die niet actief getekend worden (achtergrondtab, ingesloten preview). */
(function () {
  var rijen = [].slice.call(document.querySelectorAll('[data-ke-instroom]'));
  if (!rijen.length) return;

  var stil = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  if (stil || !('IntersectionObserver' in window)) {
    rijen.forEach(function (rij) { rij.classList.add('ke-aan'); });
    return;
  }

  function vangnet(rij) {
    function kijk() {
      if (rij.classList.contains('ke-aan')) { afhaken(); return; }
      var vak = rij.getBoundingClientRect();
      if (vak.top < (window.innerHeight || 0) && vak.bottom > 0) {
        rij.classList.add('ke-aan');
        afhaken();
      }
    }
    function afhaken() {
      removeEventListener('scroll', kijk);
      removeEventListener('resize', kijk);
    }
    addEventListener('scroll', kijk, { passive: true });
    addEventListener('resize', kijk);
    setTimeout(kijk, 1200);
  }

  var kijker = new IntersectionObserver(function (regels) {
    regels.forEach(function (regel) {
      if (!regel.isIntersecting) return;
      regel.target.classList.add('ke-aan');
      kijker.unobserve(regel.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  rijen.forEach(function (rij) {
    kijker.observe(rij);
    vangnet(rij);
  });
})();
